
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"11.083","height":"10.154","rx":"1.5","fill":"#fff","stroke":"#1BA7E1"}}),_c('path',{attrs:{"d":"M1.86 5.578l2.788-1.61v3.22l-2.789-1.61zM10.225 5.577l-2.789 1.61v-3.22l2.789 1.61z","fill":"#1BA7E1"}})])
          )
        }
      }
    